// Per-route <title>, description, canonical and robots for search engines (Google renders the SPA).
// Only the public auth pages are indexable; everything behind sign-in is noindex.
// Non-production builds keep the static noindex from public/index.html untouched.

const SITE = 'https://events.eventor.app';
const DEFAULT_TITLE = 'Log in to Eventor.app – Guest List & Check-in App';
const DEFAULT_DESCRIPTION = 'Log in to Eventor.app and start creating events. Import guest lists from Excel, '
  + 'invite your team and check guests in on iPad, iPhone and Android. Swiss made.';

const PAGES = {
  AuthSignIn: {
    title: DEFAULT_TITLE,
    description: DEFAULT_DESCRIPTION,
    indexable: true,
  },
  AuthSignUp: {
    title: 'Create your free Eventor.app account – Guest List & Check-in App',
    description: 'Create a free Eventor.app account and set up your first event in minutes. Import guests from '
      + 'Excel and check them in on iPad, iPhone and Android. Swiss made.',
    indexable: true,
  },
  AuthResetPasswordSendEmail: { title: 'Reset your password – Eventor.app' },
  AuthResetPasswordSetPassword: { title: 'Set a new password – Eventor.app' },
  Dashboard: { title: 'My events – Eventor.app' },
  EventCreate: { title: 'Create event – Eventor.app' },
  SubscriptionPlans: { title: 'Subscription plans – Eventor.app' },
  TeamManagement: { title: 'Team – Eventor.app' },
  UserProfile: { title: 'Profile – Eventor.app' },
};

function upsertTag(selector, create) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  return el;
}

function setMeta(attr, key, content) {
  const el = upsertTag(`meta[${attr}="${key}"]`, () => {
    const meta = document.createElement('meta');
    meta.setAttribute(attr, key);
    return meta;
  });
  el.setAttribute('content', content);
}

export default function applySeo(route) {
  const page = PAGES[route.name] || {};
  document.title = page.title || 'Eventor.app';

  if (process.env.VUE_APP_MODE !== 'production') return;

  const description = page.description || DEFAULT_DESCRIPTION;
  setMeta('name', 'description', description);
  setMeta('property', 'og:title', page.title || DEFAULT_TITLE);
  setMeta('property', 'og:description', description);
  setMeta('name', 'robots', page.indexable ? 'index, follow' : 'noindex, follow');

  if (page.indexable) {
    const url = `${SITE}${route.path}`;
    upsertTag('link[rel="canonical"]', () => {
      const link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      return link;
    }).setAttribute('href', url);
    setMeta('property', 'og:url', url);
  }
}
